// extracted by mini-css-extract-plugin
export default {"card":"Categoria_card__UDy+z","cardbody":"Categoria_cardbody__sVBDA"};